<template>
  <b-modal
    :id="`is-in-leave${id}`"
    modal-class="modal-style"
    ref="modal"
    v-model="modal"
  >
    <template>
      <p class="modal-style-title alert-title">有請假紀錄</p>
      <div class="modal-style-content">
        <p>您好，請假期間，無法上課</p>
      </div>
    </template>

    <template v-slot:modal-footer>
      <button class="custom-btn modal-style-single-btn" @click="closeModal()">
        確定
      </button>
    </template>
  </b-modal>
</template>

<script>
export default {
  props: {
    id: {
      required: true,
      type: Number
    }
  },
  data() {
    return {
      modal: false
    };
  },
  watch: {
    modal(next) {
      if (next == false) {
        this.$emit('closeModal');
      }
    }
  },
  methods: {
    closeModal() {
      this.$bvModal.hide(`is-in-leave${this.id}`);
    }
  }
};
</script>
